import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";

export const rescheduleBooking = createAsyncThunk('booking/reschedule',
async ({id, data}: {id: string, data: ReschedulePayload}) => {
    const response: AxiosResponse<BookingState> = await instance.post(`v1/bookings/${id}/reschedule`, data)
    return response.data
  })



